import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';

export default function createEnhancedLocations(
    viewStateLocations: LocationPersonaControlViewState[]
): EnhancedLocation[] {
    let enhancedLocations: EnhancedLocation[] = [];

    if (viewStateLocations) {
        viewStateLocations.forEach(persona => {
            enhancedLocations.push({
                Id: persona.personaId,
                DisplayName: persona.displayName,
                PostalAddress: persona.postalAddress,
            } as EnhancedLocation);
        });
    }

    return enhancedLocations;
}
